// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__tnhTC","bgFullImg":"App_bgFullImg__a1Rjp","bgImg":"App_bgImg__oYKtk","motionBlock":"App_motionBlock__y1jv-"};